<template>
    <div class="unitList">
        <!--已解锁单元-->
        <div class="unit-block"
             :class="[item.is_try==0?'lock':'allow-active',item.is_pass==1?'green-active':'',item.is_pass==2?'green-active':'']"
             v-for="(item,index) in unitList" :key="'b'+index" @click="selectUnit(item)">
            <div class="unit-btn" :class="item.is_try==0?'':'allow-active'">
                <div>{{item.name}}</div>
            </div>
            <img v-if="item.is_try==0" class="lock-icon" src="@/assets/img/grammarTest/lock.png">
            <img v-if="item.is_pass==2&&item.is_try==1" class="lock-icon" src="@/assets/img/grammarTest/perform.png">
            <transition name="el-zoom-in-center">
                <div class="lock-unit" v-if="showPopText&&selectUnitId==item.id">
                    还未学习该单元单词
                </div>
            </transition>
        </div>
        <dynamic-box
                :windowStatus="windowStatus"
                :data="studyStage.dataSource"
                :type="studyStage.type"
                @callBack="callBack">
        </dynamic-box>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import dynamicBox from "../../templates/dynamicBox";

    import {getUnitList, studyErrorBook, getSpellData} from '@/api/grammar'
    import Lockr from 'lockr'

    export default {
        name: "grammarLearnHome",
        components: {dynamicBox},
        computed: {
            ...mapGetters(['studyStage'])
        },
        data() {
            return {
                courseId: '',//课程id
                unitList: [],//单元列表
                atUnit: '',//当前所在单元
                windowStatus: false,//显示语音识别模块
                ShowAppraisalPop: false,//显示语音测评模块
                ShowSpellPop: false,//显示拼写强化
                isShowUnitInfo: false,//是否显示单元简介
                type: 6,//是否显示单元简介
                showPopText:'',
                selectUnitId:'',
            };
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            // 动态组件回调
            callBack(data) {
                if (data.type == 'close') {
                    this.windowStatus = false;
                }
            },
            //获取单元列表
            async getUnitList() {
                this.courseId = this.$route.query.id
                let params = {
                    token: Lockr.get('token'),
                    grammar_curriculum_id: this.courseId,
                    type: this.type,
                }
                let result = await getUnitList(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.unitList = result.data // 单元列表
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            //选择单元
            async selectUnit(item) {
                this.selectUnitId=item.id
                if (item.is_try == 0) {
                    this.showPopText = true
                    setTimeout(() => {
                        this.showPopText = false
                    }, 2000)
                    return null
                }
                let params = {
                    token: Lockr.get('token'),
                    unit_id: item.id,
                    type: this.type,
                }
                let result = await studyErrorBook(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.atUnit = result.data
                    let data = {
                        title: '语法学习错题本',
                        type: 'studyError/grammarStudy',
                        dataSource: this.atUnit,
                        courseType: 'yfctb',
                        closeBtn: false,
                        unitType: this.type,
                        position: result.data.position || 1
                    }
                    data.dataSource.unit_id = item.id
                    this.CHANGE_STUDY_TYPE(data)
                    this.windowStatus = true
                } else {
                    this.$alert(result.msg, '温馨提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                }
            },
            // 关闭语音识别
            clickedVoicePop() {
                this.ShowVoicePop = false;
            },
            //关闭语音测评
            clickedAppraisalPop() {
                this.ShowAppraisalPop = false;
            },
            //关闭拼写强化
            clickedSpellPop() {
                this.ShowSpellPop = false;
            },
        },
        watch: {
            $route(to, from) {
                this.getUnitList()
            }
        },
        created() {
            this.getUnitList()
        },
    }
</script>

<style scoped lang='less'>
    .unitList {
        border: 1px solid #DEDEDE;
        margin: 0 10px;
        display: flex;
        flex-wrap: wrap;

        .unit-block {
            width: 18%;
            height: 70px;
            margin: 10px 1%;
            background: linear-gradient(270deg, rgba(255, 197, 103, 1) 0%, rgba(255, 157, 0, 1) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            /*flex-direction: column;*/
            font-size: 19px;
            color: #fff;
            cursor: pointer;
            position: relative;
            transition: all .3s;
            overflow: unset;
            position: relative;

            .unit-btn {
                flex: 1;
                transition: all .5s;

                > div {
                    height: 70px;
                    line-height: 70px;
                    text-align: center;
                }
            }

            .allow-active:hover {
                background: #FF640C;
            }

            .unit-hidden {
                margin-right: -35px;
                transition: all .5s;
                width: 35px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                > div {
                    width: 35px;
                    height: 35px;
                    transition: all .5s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                > div:hover {
                    background: #FF640C;
                }

                .video-icon {
                    width: 20px;
                    height: 20px;

                }

                .bell-icon {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .lock-unit {
            position: absolute;
            top: -50%;
            left: 20px;
            font-size: 14px;
            white-space: nowrap;
            padding: 5px 8px;
            background: #00b29f;
        }

        .lock-unit:before {
            position: absolute;
            border: 5px solid;
            border-color: #00b29f transparent transparent transparent;
            content: '';
            bottom: -10px;
        }
        .green-active {
            background: #00D8A0;
        }

        .allow-active:hover {
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

            .unit-hidden {
                margin-right: 0;
            }
        }

        .lock {
            background: #818181;
        }

        .lock:hover {
            background: #818181;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }

        .lock-icon {
            position: absolute;
            bottom: 5px;
            right: 5px;
            height: 25px;
            width: 25px;
        }
    }
    .el-message-box {
        width: 1000px;
        /*min-height: 560px;*/
    }

    .el-message-box__wrapper {
        background: rgba(0, 0, 0, 0.3);

        .el-message-box__header {
            padding: 25px;
            border-bottom: 1px solid #dcdcdc;
        }

        .el-message-box__content {
        }

        .el-message-box__btns {
            font-size: 14px;
            position: absolute;
            right: 0;
            bottom: 0;
        }



        .left-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            > div:nth-of-type(1) {
                display: flex;
                align-items: center;

                p {
                    font-size: 18px;
                }

                img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
            }

            .countDown {
            background: url('../../../../assets/img/grammarTest/time_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 50px;
            height: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        }

        .content-box {
            min-height: 550px;
            overflow-y: scroll;
            transition: all .5s;

            .analysis-box {
                img {
                    width: 100%;
                }
            }
        }
    }
    .btn1 {
        top: 10px!important;
        right: 10px;
    }
</style>